// controlApi.js
import { createApi} from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const ImportControlApi = createApi({
  reducerPath: "ImportControlApi",
  baseQuery,
  tagTypes: ["ImportControlDetails"],
  endpoints: (builder) => ({

    getImportControlDetailsById: builder.query({
      query: ({id}) => `/import/product/controlDetails/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];

        // Ensure it's always an array
        const normalized = Array.isArray(data) ? data : [data];

        // Add `id` field from exportEntityId
        return normalized.map((item) => ({
          ...item,
          id: item.importControlDetailsId, // 👈 use backend's exportEntityId
        }));
      },
      providesTags: ["ImportControlDetails"],
    }),

    createImportControlDetail: builder.mutation({
      query: ({id = "68f9f3a929531674453c2451", ...data}) => ({
        url: `/import/product/controlDetails/${id}`,
        method: "PUT", 
        body: { importControlDetails:data },
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["ImportControlDetails"],
    }),

    updateImportControlDetail: builder.mutation({
      query: ({ id = "68f9f3a929531674453c2451",subId , ...data  }) => ({
        url: `/import/product/controlDetails/${id}/${subId}`,
        method: "PUT",
        body: { importControlDetails:data},
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["ImportControlDetails"],
    }),

    deleteImportControlDetail: builder.mutation({
      query: ({id}) => ({
        url: `/import/product/controlDetails/${id}`,
        method: "DELETE",
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["ImportControlDetails"],
    }),
  }),
});

export const {
  useLazyGetImportControlDetailsByIdQuery,
  useCreateImportControlDetailMutation,
  useUpdateImportControlDetailMutation,
  useDeleteImportControlDetailMutation,
} = ImportControlApi;
